import {
  projectQueryParamKeys,
  type ProjectQueryParams,
} from '@client/models/router.model';
import { PROPOSAL_SEARCH_PARAM } from '@client/hooks/use-selected-proposal-id.hooks';

/**
 * Serializes {@link ProjectQueryParams} into {@link URLSearchParams}.
 * Omits undefined values.
 */
export const projectQueryParamsToSearchParams = (
  params: ProjectQueryParams,
): URLSearchParams => {
  const searchParams = new URLSearchParams();
  for (const key of projectQueryParamKeys) {
    switch (key) {
      case 'proposal': {
        const value = params.proposal;
        if (value) searchParams.set(PROPOSAL_SEARCH_PARAM, value);
        break;
      }
    }
  }
  return searchParams;
};

/**
 * Appends the current {@link ProjectQueryParams} as a query string to a path
 * or absolute URL. Returns {@link href} unchanged when there is nothing to add.
 */
export const appendProjectQueryParamsToHref = (
  href: string,
  params: ProjectQueryParams,
): string => {
  const searchParams = projectQueryParamsToSearchParams(params);
  const qs = searchParams.toString();
  if (!qs) return href;
  const sep = href.includes('?') ? '&' : '?';
  return `${href}${sep}${qs}`;
};
